export enum PermissionEnum {
	NONE = 1, // DEFAULT - disabled, invisible and NOT IN VALUE!

	// the following states are in value!

	HIDDEN = 2, // READ-ONLY and invisible
	READ = 3, // READ-ONLY
	WRITEONCE = 4, // FULL access if no value; READ if value
	FULL = 5 //  FULL access
}

export function getPermissionEnumKey(value: number): string {
	return PermissionEnum[value] ?? PermissionEnum.NONE;
}
